import React, { Component } from 'react'
import LabelError from '../LabelError'
import Label from '../Label'

export default class CheckboxField extends Component {
    render() {
        const {
          name,
          label,
          error,
          required,
          errorDisabled = false,
          value,
        }  = this.props

        return (
          
          <div className="flex flex-col justify-start align-center ">
            <div className="flex flex-row justify-start align-center ">
              <input 
                  type="checkbox"
                  name={name} 
                  value={value} 
                  className=" p-2 bg-zinc-100 rounded-lg "
                  onChange={this.props.onChange}
              />
              <Label name={ name } label={ label } type="checkbox"  required={ required }/>
            </div>
            <LabelError error={error} errorDisabled={errorDisabled} name={name} value={value} />
          </div>
        )
      }
}
